export const datum = (iso: string | null | undefined) =>
  iso ? new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/Amsterdam' }).format(new Date(iso)) : '—'

export const datumTijd = (iso: string | null | undefined) =>
  iso ? new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' }).format(new Date(iso)) : '—'

export const getal = (n: number) => new Intl.NumberFormat('nl-NL').format(n)

export function geleden(iso: string): string {
  const s = (Date.now() - new Date(iso).getTime()) / 1000
  if (s < 90) return 'zojuist'
  if (s < 3600) return `${Math.round(s / 60)} min geleden`
  if (s < 86400) return `${Math.round(s / 3600)} uur geleden`
  const d = Math.round(s / 86400)
  return d === 1 ? 'gisteren' : d < 30 ? `${d} dagen geleden` : datum(iso)
}

export const punten = (n: number) => `${getal(n)} ${Math.abs(n) === 1 ? 'punt' : 'punten'}`
